export default __webpack_public_path__ + "static/media/my-back-office.76f0fe9f.svg";